import styled from 'styled-components'
import { StyledCard } from '../Card/Card.style'

export const StyledCardSkeleton = styled(StyledCard)<{ hasChild?: boolean }>`
  display: unset;
`

export const StyledDriverSkeleton = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 1rem;
  padding: ${props => props.theme.spacing.medium};
  border-radius: ${props => props.theme.radius.normal};
  border: 1px solid ${props => props.theme.colors.secondary[100]};

  &:not(:last-of-type) {
    margin-bottom: ${props => props.theme.spacing.medium};
  }
`

export const TripSkeletonContainer = styled.div`
  background: white;
  padding: 1rem;
  margin-bottom: 1rem;
  & > div:first-of-type {
    display: flex;
    gap: 1rem;
    & > div {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      flex: 1;
    }
  }
`

export const StyledSideBarSkeleton = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${props => props.theme.spacing.small};
`

export const StyledFavRouteSkeleton = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: ${props => props.theme.spacing.medium};
`
